export const CANVA_BASE_URL = 'https://www.canva.com/api';
export const CANVA_CONNECT_API_BASE_URL =
  'https://api.canva.com/rest';

export const canva_endpoints = {
  REDIRECT: '/canva/oauth/redirect',
  AUTHORIZE: '/oauth/authorize',
};

export const CANVA_USER_SCOPES = [
  'asset:read',
  'asset:write',
  'brandtemplate:content:read',
  'brandtemplate:meta:read',
  'design:content:read',
  'design:content:write',
  'design:meta:read',
  'profile:read',
];
